module.exports = __webpack_public_path__ + "static/img/7.4d09dd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/7.png
// module id = P8PP
// module chunks = 0